<template>
	<form
		:class="{ 'product-filters--minify': minify }"
		class="product-filters"
		@submit.prevent="getSearch"
	>
		<table class="simple-table">
			<tr>
				<th>카테고리</th>
				<td colspan="3">
					<single-category-selector
						v-model="categoryIds"
						ref="categorySelector"
					/>
				</td>
			</tr>
			<tr>
				<th>브랜드</th>
				<td>
					<search-brand @change="getBrand" ref="searchBrand" />
				</td>
				<th>제품명</th>
				<td>
					<input
						v-model="productName"
						type="text"
						aria-label="제품명"
					/>
				</td>
			</tr>
			<tr>
				<th>기간</th>
				<td>
					<DateRange v-model="dateRange" type="date" />
				</td>
				<th>상태</th>
				<td>
					<RadioList v-model="status" :radioList="statusOptions" />
					<button
						@click="filterMinifyToggle"
						class="product-filters__minify-toggle"
					>
						검색조건 {{ minify ? '펼치기' : '접기' }}
					</button>
				</td>
			</tr>
		</table>
		<div class="btn-wrap-main">
			<button type="submit" class="btn-main blue" v-text="'검색하기'" />
			<button
				type="button"
				class="btn-main blue bordered"
				v-text="'검색조건 초기화'"
				@click="initFilters"
			/>
		</div>
	</form>
</template>
<script>
	import moment from 'moment';
	import SingleCategorySelector from '@/components/SingleCategorySelector';
	import SearchBrand from '@/components/SearchBrand';
	import DateRange from '@/components/DateRange';
	import RadioList from '@/components/RadioList.vue';

	export default {
		name: 'EditorProductFilters',
		components: {
			SingleCategorySelector,
			SearchBrand,
			DateRange,
			RadioList,
		},
		data() {
			return {
				categoryIds: {
					idFirstCategory: null,
					idSecondCategory: null,
					idThirdCategory: null,
				},
				productName: '',
				idBrand: null,
				dateRange: { from: '', to: '' },
				status: '',
				statusOptions: [
					{ id: '', value: '전체' },
					{ id: 'ready', value: '전시예정' },
					{ id: 'open', value: '전시중' },
					{ id: 'closed', value: '비전시' },
				],
				minify: false,
			};
		},
		methods: {
			getBrand(event) {
				this.idBrand = event.idBrand;
			},
			getSearch() {
				const params = {
					firstCategoryV2Id: this.categoryIds.idFirstCategory,
					secondCategoryV2Id: this.categoryIds.idSecondCategory,
					thirdCategoryV2Id:
						this.categoryIds.idThirdCategory === 'all'
							? null
							: this.categoryIds.idThirdCategory,
					showMergedChildren:
						this.categoryIds.idThirdCategory === 'all',
					productTitle: this.productName,
					idBrand: this.idBrand,
					dateRange: [
						this.dateRange.from
							? moment(this.dateRange.from, 'YYYY-MM-DD').format(
									'x'
								)
							: null,
						this.dateRange.to
							? moment(this.dateRange.to, 'YYYY-MM-DD')
									.endOf('date')
									.format('x')
							: null,
					],
					status: this.status,
				};

				this.$emit('search', params);
			},
			initFilters() {
				this.categoryIds.idFirstCategory = null;
				this.categoryIds.idSecondCategory = null;
				this.categoryIds.idThirdCategory = null;
				this.$refs.categorySelector.init();

				this.productName = '';

				this.idBrand = null;
				this.$refs.searchBrand.init();

				this.dateRange = { from: '', to: '' };

				this.status = '';
			},
			filterMinifyToggle() {
				this.minify = !this.minify;
			},
		},
	};
</script>
<style lang="scss">
	.simple-table {
		position: relative;
		background: #fff;
	}

	.product-filters--minify {
		max-height: 1px;
		overflow: hidden;

		.product-filters__minify-toggle {
			position: fixed;
			bottom: initial;
			top: 157px;
			right: 4em;
		}
	}

	.product-filters__minify-toggle {
		position: absolute;
		right: 1em;
		bottom: -48px;
		border: 1px solid #dfe6ee;
		padding: 1em;
		border-radius: 0 0 10px 10px;
		font-weight: bold;
		background: #fff;
	}

	.product-filters__status {
		margin-right: 2em;

		&:last-child {
			margin-right: 0;
		}
	}
</style>
